import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function Feature(props) {
  var base = new Base()
  const momentNow = moment()
  const [infoData, setInfoData] = useState({})
  const [arr, setArr] = useState([
    {
      id: '',
      image: 'url(assets/images/room/feature-1-1.jpg?rnd=' + momentNow.format('HHmmss') + ')',
      title: 'Free Parking',
      subtitle: 'It is a long established fact that a reader will be distred by the readable',
      icon: 'icon-car-1',
    },
    {
      id: '',
      image: 'url(assets/images/room/room-1-1.jpg?rnd=' + momentNow.format('HHmmss') + ')',
      title: 'Wifi Internet',
      subtitle: 'It is a long established fact that a reader will be distred by the readable',
      icon: 'icon-wifi-1',
    },
    {
      id: '',
      image: 'url(assets/images/room/room-1-2.jpg?rnd=' + momentNow.format('HHmmss') + ')',
      title: '24/7 Support',
      subtitle: 'It is a long established fact that a reader will be distred by the readable',
      icon: 'icon-customer-service-1',
    },
    {
      id: '',
      image: 'url(assets/images/room/room-1-3.jpg?rnd=' + momentNow.format('HHmmss') + ')',
      title: 'Daily Breakfast',
      subtitle: 'It is a long established fact that a reader will be distred by the readable',
      icon: 'icon-wifi-1',
    },
  ])

  useEffect(() => {
    get_info_data()
    get_feature_data()
  }, [])

  async function get_info_data() {
    var response = await base.request(base.url_api + "/info?type=room_feature")

    if(response != null){
      if(response.status == "success"){
        setInfoData(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  async function get_feature_data() {
		var response = await base.request(base.url_api + "/feature/room/all")

		if(response != null){
			if(response.status == "success"){
        for(let data of response.data){
          data.image = data.url_image
        }
				setArr(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  return (
    <section class="feature-two">
      <div class="container">
        <div class="sec-title text-center">

          {/* <img src="assets/images/shapes/sec-title-s-1.png" alt="Discover our All" class="sec-title__img" /> */}


          <h6 class="sec-title__tagline bw-split-in-right" style={{ fontSize: '.8rem', }}>{infoData.title}</h6>

          <h3 class="sec-title__title bw-split-in-up" style={{ fontSize: '3.125rem', }}>{infoData.subtitle}</h3>
        </div>
        <div class="row gutter-y-30">
          {
            arr.map((data, index) => (
              <div class=" col-xl-3 col-lg-4 col-6">
                <div class={index % 2 == 0 ? "feature-two__item" : "feature-two__item feature-two__item--two"} data-wow-duration='1500ms' data-wow-delay='300ms'>
                  <div class="feature-two__item__bg" style={{ backgroundImage: data.image, }}></div>
                  
                  {
                    index % 2 == 0 ? 
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '15rem', }}>
                      {/* <div style={{ width: '125px', maxWidth: '100%', height: '125px', maxHeight: '100%', }} className="mb-3"> */}
                        <img className="feature-two__item__icon" src={data.url_image} alt={"Room Feature " + index} style={{ border: '0 solid #288AAC', backgroundColor: '#288AAC', width: '125px', maxWidth: '100%', height: 'auto', objectFit: 'cover', aspectRatio: 1, }}/>
                      {/* </div> */}
                      {/* <div class="feature-two__item__icon">
                        <i class={data.icon}></i>
                      </div> */}
                      <div class="feature-two__item__content">
                        <h3 class="feature-two__item__title" style={{ fontSize: '1.4rem', }}>{data.title}</h3>
                        {/* <p class="feature-two__item__text">{data.subtitle}</p> */}
                        {/* <a href="room-details-2.html" class="solinom-btn solinom-btn--base">Read More</a> */}
                      </div>
                      {/* <div class="feature-two__item__element"><img src={"assets/images/shapes/frame-1-1.png?rnd=" + momentNow.format('HHmmss')} alt /></div>
                      <div class="feature-two__item__element-two"><img src={"assets/images/shapes/frame-1-2.png?rnd=" + momentNow.format('HHmmss')} alt /></div> */}
                    </div>
                    :
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '15rem', }}>
                      <div class="feature-two__item__content">
                        <h3 class="feature-two__item__title" style={{ fontSize: '1.4rem', }}>{data.title}</h3>
                        {/* <p class="feature-two__item__text">{data.subtitle}</p> */}
                        {/* <a href="room-details-2.html" class="solinom-btn solinom-btn--base">Read More</a> */}
                      </div>
                      {/* <div style={{ width: '125px', maxWidth: '100%',  height: '125px', maxHeight: '100%', }} className=""> */}
                        <img className="feature-two__item__icon" src={data.url_image} alt={"Room Feature " + index} style={{ border: '0 solid #288AAC', backgroundColor: '#288AAC', width: '125px', maxWidth: '100%', height: 'auto', objectFit: 'cover', aspectRatio: 1, }}/>
                      {/* </div> */}
                      {/* <div class="feature-two__item__icon">
                        <i class={data.icon}></i>
                      </div> */}
                      {/* <div class="feature-two__item__element-three"><img src={"assets/images/shapes/frame-1-3.png?rnd=" + momentNow.format('HHmmss')} alt /></div>
                      <div class="feature-two__item__element-fore"><img src={"assets/images/shapes/frame-1-4.png?rnd=" + momentNow.format('HHmmss')} alt /></div> */}
                    </div>
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
};
